import Phaser from "phaser";
import { WORLD } from "@/config";
import { BootScene } from "@/scenes/BootScene";
import { ZoneScene } from "@/scenes/ZoneScene";
import { SideScrollScene } from "@/scenes/SideScrollScene";
import { setSession, restoreSession } from "@/auth/session";
import { showAuthOverlay } from "@/auth/AuthOverlay";

async function boot(): Promise<void> {
  if (!restoreSession()) {
    const auth = await showAuthOverlay();
    setSession(auth.token, auth.displayName);
  }

  new Phaser.Game({
    type: Phaser.AUTO,
    parent: "game",
    width: WORLD.width,
    height: WORLD.height,
    backgroundColor: "#0b0d12",
    pixelArt: false,
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    scene: [BootScene, ZoneScene, SideScrollScene],
  });
}

boot().catch((err) => {
  console.error("boot failed", err);
  const hud = document.getElementById("hud");
  if (hud) hud.textContent = `boot error: ${String(err)}`;
});

declare global {
  interface Window {
    __MYTHGLADE__?: { boot: typeof boot };
  }
}

if (import.meta.env.DEV) {
  window.__MYTHGLADE__ = { boot };
}
